var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{class:['fullname','nohalo', {'hidden': _vm.$route.name === 'home'}],attrs:{"to":"/"}},[_vm._v("Thomas Haaf"),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }